export type ContactForm = {
  sei: string;
  mei: string;
  kanaSei: string;
  kanaMei: string;
  email: string;
  emailConfirm: string;
  tel: string;
  body: string;
};

/** ContactForm の空初期値（キー一覧の正本） */
export const createEmptyContactForm = (): ContactForm => ({
  sei: '',
  mei: '',
  kanaSei: '',
  kanaMei: '',
  email: '',
  emailConfirm: '',
  tel: '',
  body: '',
});

export const CONTACT_FORM_KEYS = Object.keys(
  createEmptyContactForm(),
) as (keyof ContactForm)[];

/** 会員詳細からお問い合わせフォーム値を組み立てる */
export const createContactFormFromMember = (member: {
  sei: string;
  mei: string;
  kana_sei: string;
  kana_mei: string;
  email: string;
  tel: string;
}): ContactForm => ({
  ...createEmptyContactForm(),
  sei: member.sei,
  mei: member.mei,
  kanaSei: member.kana_sei,
  kanaMei: member.kana_mei,
  email: member.email,
  emailConfirm: member.email,
  tel: member.tel,
});
